import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import OpsLayout from '../../components/layout/OpsLayout';
import { Card, CardContent } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Trash2, Clock, CheckCircle, XCircle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const STATUS_STYLE = {
  pending: 'bg-amber-500/15 text-amber-400 border-amber-500/40',
  approved: 'bg-emerald-500/15 text-emerald-400 border-emerald-500/40',
  rejected: 'bg-red-500/15 text-red-400 border-red-500/40',
};
const STATUS_ICON = { pending: Clock, approved: CheckCircle, rejected: XCircle };

export default function OpsDeletionRequestsPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchRows = useCallback(() => {
    axios.get(`${API}/ops/deletion-requests`)
      .then((r) => setRows(r.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { fetchRows(); }, [fetchRows]);

  return (
    <OpsLayout>
      <div className="space-y-4">
        <div className="border-b border-border pb-4 flex items-center gap-3">
          <Trash2 className="w-6 h-6 text-primary" strokeWidth={1.5} />
          <div>
            <h1 className="text-2xl font-barlow tracking-widest text-foreground">MY DELETION REQUESTS</h1>
            <p className="text-xs text-muted-foreground mt-1">
              Shifts/events stay unchanged until the Primary Admin approves your request.
            </p>
          </div>
        </div>
        {loading ? (
          <p className="py-12 text-center text-sm text-muted-foreground">Loading…</p>
        ) : rows.length === 0 ? (
          <p className="py-12 text-center text-sm text-muted-foreground" data-testid="ops-del-empty">
            No deletion requests yet. Use "Request Deletion" on a shift or event.
          </p>
        ) : (
          <div className="space-y-2" data-testid="ops-del-list">
            {rows.map((r) => {
              const Icon = STATUS_ICON[r.status] || Clock;
              return (
                <Card key={r.id} className="bg-card border-border rounded-sm" data-testid={`ops-del-${r.id}`}>
                  <CardContent className="p-4 flex flex-col sm:flex-row sm:items-center gap-2">
                    <div className="min-w-0 flex-1">
                      <p className="text-sm font-medium truncate">{r.label}</p>
                      <p className="text-xs text-muted-foreground">
                        Requested {new Date(r.created_at).toLocaleString('en-GB')}
                        {r.reason ? ` · Reason: ${r.reason}` : ''}
                        {r.decided_by_name ? ` · Decided by ${r.decided_by_name}` : ''}
                      </p>
                    </div>
                    <Badge className={`border text-[10px] uppercase tracking-wider shrink-0 ${STATUS_STYLE[r.status] || ''}`}>
                      <Icon className="w-3 h-3 mr-1" /> {r.status}
                    </Badge>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        )}
      </div>
    </OpsLayout>
  );
}
